export default __webpack_public_path__ + "static/media/primary.1d7acf5a46ca97442015ab9a7a5894b8.svg";